<template>
  <div>

    <div class="head_box">
      <div class="nav">

        <div class="logo_box">
          <img src="img/logo.svg" alt="" />
        </div>

        <div class="btn_box">
          <a class="home_box" href="https://taiwanngo.tw/" target="_blank">
            回首頁
          </a>
        </div>
      </div>
    </div>


    <div class="banner_box">

      <div class="container">

        <div class="title_box animate-box fade-up" v-scroll>
          <h1><img src="img/title_bg_text.svg" alt=""></h1>
        </div>

        <div class="subtitle_box animate-box fade-up" v-scroll="0.1">
          <p>是否滿意我們網站所提供的各項資訊及功能呢？<br>快來說說你的想法吧。
          </p>
        </div>

        <div class="btn_box animate-box zoom-in" v-scroll="0.2">
          <button class="join_btn" @click="scrollToBox">訂閱電子報並填寫問卷參加抽獎</button>
        </div>

        <div class="text_box">

          <div class="title animate-box fade-up" v-scroll="0.25">
            <p>活動時間：115年9月1日（二）至10月1日（四）</p>
          </div>

          <div class="text animate-box fade-up" v-scroll="0.3">
            <p class="subtitle">
              <img src="img/gift_b.svg" alt="">
              活動獎品
            </p>

            <ul class="list">
              <li class="animate-box fade-up" v-scroll="0.15">
                <p>Edenred 即享卡5,000元</p>
                <p>1名</p>
              </li>

              <li class="animate-box fade-up" v-scroll="0.2">
                <p>Edenred 即享卡2,000元</p>
                <p>2名</p>
              </li>

              <li class="animate-box fade-up" v-scroll="0.25">
                <p>Edenred 即享卡500元</p>
                <p>10名</p>
              </li>

            </ul>
          </div>
        </div>

      </div>

    </div>

    <div class="sea">
      <img class="img" src="img/bg_sea2.svg" alt="">
    </div>

    <div class="box">

      <div class="information_box animate-box fade-up" v-scroll="0.2">
        <div class="container">

          <div class="text_box">

            <div class="title">
              <p>填寫人資料</p>
            </div>

            <div class="text">

              <div class="group_box animate-box fade-up" v-scroll="0.25">

                <div class="img_box">
                  <img src="img/name_icon.svg" alt="">
                </div>

                <div class="group">
                  <label for="name">姓名<span class="required">*</span></label>
                  <input type="text" class="form_control" id="name" placeholder="請輸入真實姓名" v-model="form.name">
                </div>

              </div>

              <div class="group_box animate-box fade-up" v-scroll="0.3">

                <div class="img_box">
                  <img src="img/email_icon.svg" alt="">
                </div>

                <div class="group">
                  <label for="email">聯絡E-mail<span class="required">*</span></label>
                  <input type="text" class="form_control" id="email" placeholder="請輸入常用聯絡E-mail" v-model="form.email">
                </div>

              </div>

              <div class="group_box animate-box fade-up" v-scroll="0.35">

                <div class="img_box">
                  <img src="img/email2_icon.svg" alt="">
                </div>

                <div class="group">
                  <label for="email2">訂閱電子報E-mail<span class="required">*</span></label>

                  <div class="input_check">
                    <input type="text" class="form_control" id="email2" placeholder="請輸入訂閱電子報E-mail"
                      v-model="form.email2" :disabled="form.sameEmail">

                    <div class="form_check">
                      <input class="form-check-input" type="checkbox" value="" id="sameEmail" v-model="form.sameEmail"
                        @change="handleSameEmail">
                      <label class="form-check-label" for="sameEmail">
                        同聯絡E-mail<img src="img/question_icon.svg" alt="">
                      </label>
                    </div>
                  </div>
                </div>

              </div>

              <p class="notice animate-box fade-up" v-scroll="0.4">
                <img src="img/exclamation_icon.svg" alt="">
                以上欄位皆為必填，請確實填寫，以利我們與您聯繫。
              </p>

            </div>

          </div>

        </div>
      </div>


      <div class="questionnaire_box animate-box fade-up" v-scroll="0.2">
        <div class="container">

          <div class="text_box">

            <div class="title">
              <p>問卷開始</p>
            </div>

            <div class="text">

              <div class="questionnaire_title animate-box fade-up" v-scroll="0.1">
                <p>使用服務項目調查</p>
              </div>

              <div class="form_group">
                <label class="question_title animate-box fade-up" v-scroll="0.1">
                  您常瀏覽本網站的項目為
                  <span class="reminder">（可複選）</span>
                </label>

                <div class="check_group">
                  <!-- 所有選項 -->
                  <div class="form-check animate-box fade-up" v-scroll="0.1" v-for="item in usedItems" :key="item.id">
                    <input class="form-check-input" type="checkbox" :id="'usedItems_' + item.id" :value="item.value"
                      v-model="selectedUsedItems" :disabled="isSubmitted" />
                    <label class="form-check-label" :for="'usedItems_' + item.id">
                      {{ item.label }}
                    </label>
                  </div>

                  <!-- 其他選項 -->
                  <div class="form-check  animate-box fade-up" v-scroll="0.1">
                    <input class="form-check-input" type="checkbox" id="usedItems_other" v-model="useItemOther"
                      :disabled="isSubmitted" />

                    <div class="other_box">
                      <label class="form-check-label" for="usedItems_other">
                        其他
                      </label>
                      <input type="text" class="form-control" id="otherText" placeholder="" v-model="otherText"
                        :disabled="!useItemOther || isSubmitted" />
                    </div>

                  </div>
                </div>

              </div>

            </div>


            <div class="text questionnaire">
              <!-- 兩個問卷區塊 -->
              <div class="text" v-for="section in sections" :key="section.id">

                <!-- 區塊標題 -->
                <div class="questionnaire_title animate-box fade-up" v-scroll="0.1">
                  <p>{{ section.title }}</p>
                </div>

                <!-- 每一題 -->
                <div class="form_group satisfaction_box" v-for="question in section.questions" :key="question.id">

                  <!-- 題目 -->
                  <label class="question_title animate-box fade-up" v-scroll="0.1">

                    <!-- highlight 前面的文字 -->
                    {{ getTitleBefore(question) }}

                    <!-- highlight -->
                    <span class="reminder">{{ question.highlight }}</span>

                    <!-- highlight 後面的文字 -->
                    {{ getTitleAfter(question) }}

                  </label>


                  <!-- 滿意度選項 -->
                  <div class="check_group  animate-box fade-up" v-scroll="0.1">

                    <div class="form-check" v-for="item in satisfactionItems" :key="item.id">

                      <!-- input 放在 label 裡面 -->
                      <label class="form-check-label">

                        <!-- 圖片 -->
                        <!-- <div class="img_box">
                          <img :src="item.src" :alt="item.label">
                        </div> -->

                        <!-- 文字＋radio -->
                        <input class="form-check-input" type="radio" :name="`${section.id}_question_${question.id}`"
                          :value="item.value" v-model="question.answer" :disabled="isSubmitted">
                        <div class="text">
                          <div class="img_box">
                            <img :src="item.src" :alt="item.label">
                          </div>
                          {{ item.label }}
                        </div>

                      </label>

                    </div>

                  </div>

                </div>

              </div>
            </div>

            <div class="text suggestion_box animate-box fade-up" v-scroll="0.1">
              <div class="form_group">
                <label for="suggestion" class="form-label">希望本網站能再加強哪些地方，歡迎提出建議!</label>
                <textarea class="form-control" id="suggestion" rows="5" v-model="suggestion"
                  :disabled="isSubmitted"></textarea>
              </div>
            </div>

            <div class="send_box animate-box zoom-in" v-scroll="0.1">
              <button class="send_btn" type="button" @click="handleSubmit"
                :disabled="isSubmitting || isSubmitted">{{ isSubmitting ? '送出中...' : '送出問卷' }}</button>
            </div>

          </div>

        </div>
      </div>

      <div class="notice_box animate-box fade-up" v-scroll="0.1">
        <div class="container">

          <div class="notice_text">
            <div class="title">
              <p>注意事項：</p>
            </div>

            <ul class="list">
              <li v-for="(item, index) in noticeItems" :key="index">
                <p>
                  {{ item.text }}

                  <span v-if="item.highlight" class="highlight">
                    {{ item.highlight }}
                  </span>

                  <a v-if="item.linkText" :href="item.linkUrl" target="_blank" rel="noopener noreferrer">
                    {{ item.linkText }}
                  </a>

                  {{ item.afterText }}


                </p>
              </li>
            </ul>
          </div>

          <p class="footer_text">外交部非政府組織國際事務會</p>

        </div>
      </div>


    </div>


    <div class="sendModal modal fade" id="sendModal" tabindex="-1" aria-labelledby="sendModalLabel" aria-hidden="true"
      data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

          <div class="modal-body">

            <div class="title">
              <h2>問卷送出成功</h2>
              <p>感謝您的寶貴意見！</p>
              <!-- <p v-if="submissionNumber">您的填寫順序為：{{ submissionNumber }}</p> -->
            </div>

            <div class="img_box">
              <img src="img/send_gift_icom.svg" alt="">
            </div>
            <div class="btn_box">
              <!-- <button type="button" class="btn cross_btn" data-bs-dismiss="modal">關閉視窗</button> -->
              <button type="button" class="btn" @click="goHome">返回首頁</button>
            </div>

          </div>

        </div>
      </div>
    </div>

  </div>
</template>
<script>
import axios from 'axios'

export default {
  name: "Home",
  components: {},
  data() {
    return {

      form: {
        name: '',
        email: '',
        email2: '',
        sameEmail: false
      },

      selectedUsedItems: [],
      useItemOther: false,
      otherText: '',
      suggestion: '',
      isSubmitting: false,
      isSubmitted: false,
      submissionNumber: '',

      // 多選欄位(最多選五個)
      usedItems: [
        { id: 1, label: "最新消息", value: "最新消息" },
        { id: 2, label: "影片專區", value: "影片專區" },
        { id: 3, label: "INGO在臺設點專區", value: "INGO在臺設點專區" },
        { id: 4, label: "NGO補助申請專區", value: "NGO補助申請專區" },
        { id: 5, label: "NGO活動預告", value: "NGO活動預告" },
        { id: 6, label: "NGO心視野專題報導", value: "NGO心視野專題報導" },
        { id: 7, label: "NGO電子報", value: "NGO電子報" },
      ],



      // 滿意度選項
      satisfactionItems: [
        {
          id: 1,
          src: 'img/expression_1.svg',
          value: '非常滿意',
          label: '非常滿意'
        },
        {
          id: 2,
          src: 'img/expression_2.svg',
          value: '滿意',
          label: '滿意'
        },
        {
          id: 3,
          src: 'img/expression_3.svg',
          value: '普通',
          label: '普通'
        },
        {
          id: 4,
          src: 'img/expression_4.svg',
          value: '不滿意',
          label: '不滿意'
        },
        {
          id: 5,
          src: 'img/expression_5.svg',
          value: '非常不滿意',
          label: '非常不滿意'
        }
      ],


      // 問卷區塊
      sections: [

        // 第一區塊：內容呈現
        {
          id: 'content',
          title: '內容呈現滿意度調查',

          questions: [
            {
              id: 1,
              title: '您認為本網站中「NGO國際事務會影片專區」內容',
              highlight: 'NGO國際事務會影片專區',
              answer: '非常滿意'
            },
            {
              id: 2,
              title: '您對本網站中「INGO在臺設點專區」資訊及呈現方式',
              highlight: 'INGO在臺設點專區',
              answer: '非常滿意'
            },
            {
              id: 3,
              title: '您對本網站中「NGO補助申請專區」資訊及呈現方式',
              highlight: 'NGO補助申請專區',
              answer: '非常滿意'
            },
            {
              id: 4,
              title: '您對本網站中「電子報」內容及樣式',
              highlight: '電子報',
              answer: '非常滿意'
            }
          ]
        },

        // 第二區塊：使用流暢度
        {
          id: 'flow',
          title: '使用流暢度滿意度調查',

          questions: [
            {
              id: 1,
              title: '您對本網站「整體架構、網頁設計、編排滿意度」',
              highlight: '整體架構、網頁設計、編排滿意度',
              answer: '非常滿意'
            },

            {
              id: 2,
              title: '您對本網站「瀏覽速度滿意度」',
              highlight: '瀏覽速度滿意度',
              answer: '非常滿意'
            },

            {
              id: 3,
              title: '您對本網站「中文版」各項資訊及功能滿意度',
              highlight: '中文版',
              answer: '非常滿意'
            },

            {
              id: 4,
              title: '您對本網站「英文版」各項資訊及功能滿意度',
              highlight: '英文版',
              answer: '非常滿意'
            }
          ]
        }

      ],

      // 注意事項
      noticeItems: [
        { text: "參加本活動同時，即同意接受本活動之活動辦法與注意事項之規範，如有違反，主辦單位得取消其參加或得獎資格。任何意圖干擾、攻擊、破壞本活動公平性之行為，主辦單位將依法追溯並求償。", },
        {
          text: "得獎名單預計於",
          highlight: '115年10月08日（星期四）在',
          linkText: 'NGO雙語網站',
          linkUrl: 'https://taiwanngo.tw/',
          afterText: "公布，另將以電郵通知得獎者；未於通知期限內回覆寄件資訊者，視同放棄得獎資格。外交部員工、本活動工作人員及非中華民國國民者不具得獎資格。",
        },
        { text: "重複填單者，僅取一次抽獎資格。倘個人資料填寫不全、不正確、中獎後無法取得聯繫，視同放棄得獎資格。", },
        { text: "獎品寄送以臺、澎、金、馬為限，若得獎者居住於海外，請提供國內代領者的聯絡方式。", },
        { text: "本抽獎活動之贈品寄送，由新客資訊有限公司代為執行，執行單位將以簡訊等方式提供中獎獎項。", },
        { text: "Edenred 即享卡可於遠東百貨、遠東SOGO百貨、家樂福、大潤發、屈臣氏、統一超商等使用。詳細使用方法請自行查詢商家網站。", },
        { text: "凡參加本次活動所獲獎項價值超過新臺幣1,000元者，依中華民國稅法相關規定須作所得申報，將電郵領據供得獎者填寫，得獎人須繳交身分證正反面影本予主辦單位代為申報並寄發所得扣繳憑單等相關作業。得獎者若無法配合，視同自動放棄得獎資格。", },
        { text: "主辦單位保有隨時修改及終止本活動之權利，如有任何變更內容或詳細注意事項將會於NGO雙語網站公告。", },
        { text: "活動期間有相關問題，請洽詢活動小組：taiwanngo@gmail.com", },

      ],


    };
  },

  // 動畫
  directives: {
    scroll: {
      inserted(el, binding) {
        const delay = binding.value || 0
        el.style.transitionDelay = `${delay}s`
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              el.classList.add('show')
            }
          })
        })
        observer.observe(el)
      }
    }
  },

  watch: {

    // 信箱
    'form.email'(newEmail) {
      if (this.form.sameEmail) {
        this.form.email2 = newEmail
      }
    }
  },

  mounted() {

  },
  methods: {

    scrollToBox() {
      const box = document.querySelector('.box')

      if (box) {
        box.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        })
      }
    },

    // 信箱同步
    handleSameEmail() {
      if (this.form.sameEmail) {
        this.form.email2 = this.form.email
      }
    },

    validateForm() {
      const name = this.form.name.trim()
      const connectEmail = this.form.email.trim()
      const newsletterEmail = this.form.email2.trim()
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      const answers = this.sections.flatMap(section =>
        section.questions.map(question => question.answer)
      )

      if (!name || !connectEmail || !newsletterEmail) {
        return '請填寫姓名、聯絡 E-mail 及訂閱電子報 E-mail。'
      }

      if (!emailPattern.test(connectEmail) || !emailPattern.test(newsletterEmail)) {
        return '請輸入正確的 E-mail 格式。'
      }

      if (this.selectedUsedItems.length === 0 && !this.useItemOther) {
        return '請至少選擇一項常瀏覽的網站項目。'
      }

      if (this.useItemOther && !this.otherText.trim()) {
        return '請填寫「其他」項目的內容。'
      }

      if (answers.some(answer => !answer)) {
        return '請完成所有滿意度題目後再送出。'
      }

      return ''
    },

    resetFormFields() {
      this.form.name = ''
      this.form.email = ''
      this.form.email2 = ''
      this.form.sameEmail = false
      this.selectedUsedItems = []
      this.useItemOther = false
      this.otherText = ''
      this.suggestion = ''
      this.sections.forEach(section => {
        section.questions.forEach(question => {
          question.answer = '非常滿意'
        })
      })
    },

    async handleSubmit() {
      if (this.isSubmitting || this.isSubmitted) return

      const validationError = this.validateForm()
      if (validationError) {
        await this.$swal.fire({
          icon: 'error',
          title: '資料尚未填寫完整',
          text: validationError,
          confirmButtonText: '確定'
        })
        return
      }

      this.isSubmitting = true

      try {
        this.$swal.fire({
          title: '送出中',
          text: '請稍候...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => this.$swal.showLoading()
        })

        await this.$recaptchaLoaded()
        const recaptchaToken = await this.$recaptcha('submit_form')
        const answers = this.sections.flatMap(section =>
          section.questions.map(question => question.answer)
        )
        const formData = new URLSearchParams()

        formData.append('name', this.form.name.trim())
        formData.append('connect_email', this.form.email.trim())
        formData.append('newsletter_email', this.form.email2.trim())
        formData.append('use_item', this.selectedUsedItems.join(','))
        formData.append('use_item_other', String(this.useItemOther))
        formData.append('other', this.useItemOther ? this.otherText.trim() : '')
        answers.forEach((answer, index) => {
          formData.append(`question${index + 1}`, answer)
        })
        formData.append('suggestion', this.suggestion.trim())
        formData.append('captcha', recaptchaToken)

        const response = await axios.post(
          'https://taiwanngo.tw/Home/Survey2026',
          formData,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        )
        const result = response.data

        if (result && result.ok) {
          this.submissionNumber = result.Number
          this.resetFormFields()
          this.isSubmitted = true
          this.$swal.close()

          this.$nextTick(() => {
            // window.scrollTo({
            //   top: 0,
            //   behavior: 'smooth'
            // })

            const modalElement = document.getElementById('sendModal')
            if (modalElement && window.bootstrap) {
              window.bootstrap.Modal.getOrCreateInstance(modalElement, {
                backdrop: 'static',
                keyboard: false
              }).show()
            }
          })
          return
        }

        await this.$swal.fire({
          icon: 'error',
          title: '送出失敗',
          text: result && result.error ? result.error : '發生錯誤，請稍後再試一次。',
          confirmButtonText: '確定'
        })
      } catch (error) {
        const isRecaptchaError = error && error.message &&
          error.message.toLowerCase().includes('recaptcha')

        await this.$swal.fire({
          icon: 'error',
          title: isRecaptchaError ? '驗證失敗' : '網路錯誤',
          text: isRecaptchaError
            ? 'reCAPTCHA 驗證發生錯誤，請重新整理頁面後再試一次。'
            : '請檢查網路連線後再試一次。',
          confirmButtonText: '確定'
        })
      } finally {
        this.isSubmitting = false
      }
    },

    // 標題文字
    // 取得 highlight 前面的文字
    getTitleBefore(question) {
      if (!question.highlight) {
        return question.title
      }

      return question.title.split(question.highlight)[0]
    },

    // 取得 highlight 後面的文字
    getTitleAfter(question) {
      if (!question.highlight) {
        return ''
      }

      const parts = question.title.split(question.highlight)

      return parts[1] || ''
    },


    // 注意事項文字
    highlightText(text, keyword) {
      if (!keyword) return text

      return text.replace(
        new RegExp(keyword, 'g'),
        `<span class="highlight">${keyword}</span>`
      )
    },


    // 返回首頁
    goHome() {
      window.location.href = 'https://taiwanngo.tw/'
    },

  },
};
</script>
